import BaseContactEntity from "./BaseContactEntity";

export default class PersonContactEntity extends BaseContactEntity {
    private _personId: number;

    public get PersonId(): number {
        return this._personId;
    }

    public set PersonId(value: number) {
        this._personId = value;
    }

    static fromOdata(odataItem: any, entity: PersonContactEntity): PersonContactEntity {
        super.fromOdata(odataItem, entity);
        entity.PersonId = odataItem["PersonId"];
        return entity;
    }
}
